<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">
    <t-input v-model="form.name"  :add-error="error.name" label="Perfil de Local" submitted focus required/>
  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";

export default {
  name: "TypeEnterpriseDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-type-enterprise",
      title: "Cadastro rápido de Perfil Local",
      okText: "Incluir Perfil Local",
      form: {
        typeEnterpriseId: 0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    showModal() {

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora

    },

    async onSubmit() {

      //Validações específicas da tela

      await this.setInsertDialog("place/type-enterprise", (item) => {

        this.itemInserted.value = item.typeEnterpriseId
        this.itemInserted.text = this.form.name

        this.successInsert()

      })

    }
  },
  watch:{
    noOptionAdd(){
      this.form.name = this.noOptionAdd
    }
  }
}
</script>
